import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractBaseDetailsComponent } from '../../../core/component/abstract-base-details-component';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';
import { CommonSelectListService } from '../../service/common-select-list.service';
import { OrgProfileModal } from '../../../modules/org-profile/modal/org-profile-modal';
import { QuotationModel } from '../../../modules/quotation/model/quotation-model';
import { QuotationDetailModel } from 'src/app/modules/quotation/model/quotation-detail-model';
import { SystemConfigService } from 'src/app/system-config/service/system-config.service';
import { SystemConfigSettingModel } from '../../model/system-config-setting-model';
import { ACLService } from '../../AclService/acl.service';
import { UserModal } from 'src/app/modules/user/modal/user-modal';
import { QuotationService } from 'src/app/modules/quotation/service/quotation.service';

const refNo = 'refNo.';
const description = 'description';
const buyerMaterialCode = 'buyerMaterialCode';
const moduleName = 'Quotation';
const item = 'item';

@Component({
  selector: 'app-quotation-print',
  templateUrl: './quotation-print.component.html',
  styleUrls: ['./quotation-print.component.css'],
})
export class QuotationPrintComponent extends AbstractBaseDetailsComponent implements OnInit {
  public organization: OrgProfileModal;
  public imgURL: string;
  public qrImgURL: string;
  public modeOfTransport: string;

  @Input()
  public data: QuotationModel;

  @Input()
  public isHideHeaderFooter: boolean;

  @Input() public isUpdateComponent: boolean;

  @Output('modalCancel') onModalCancel: EventEmitter<any> = new EventEmitter<any>();

  @Output('onSave') onSave: EventEmitter<any> = new EventEmitter<any>();

  buyerMaterialCodes: Array<BuyerMaterialCode>;
  descriptions: Array<DescriptionDTO>;
  totalProductQuantity: number;
  paramArray = new Array<DynamicParams>();
  paramobj = new DynamicParams();
  totalProductAmt: number;
  totalDiscount: number;
  totalAmount: number;
  totalAmountWithGST: number;
  totalGSTAmount: number;
  subject: string;
  public isAlaska: boolean = false;
  isCgst: boolean = false;
  isIgst: boolean = false;
  public sysConfig: SystemConfigSettingModel = new SystemConfigSettingModel(this.sysConfigService);
  isDiagonal: boolean = false;
  yourRefNo: string;
  loggedInUser: UserModal;
  printData: QuotationPrintModel;
  description: string;
  buyerMaterialCode: string;
  paymentDays: number = 30;
  itemWiseDesc = [];
  signImg: string;
  printby: UserModal;

  constructor(
    public sysConfigService: SystemConfigService,
    public toaster: ToastrService,
    public aclService: ACLService,
    private service: CommonSelectListService,
    public Service: QuotationService,
    private quotationService: QuotationService
  ) {
    super(toaster);
    if (localStorage.getItem('activeUser')) {
      this.printby = JSON.parse(localStorage.getItem('activeUser'));
    }
  }

  ngOnInit() {
    console.log("dataaa",this.data);
    this.getOrganisationDetails();
    this.getactiveuserDetails();
    this.getCurrentUser();
    setTimeout(() => {
      this.getTotal();
    },300);
    this.isAlaska = this.sysConfig.partnerKey == 'Alaska';
    this.isDiagonal = this.sysConfig.partnerKey == 'Diagonal';
    this.getByModuleNameId(this.data.id);
  }
  getCurrentUser() {
    this.aclService.getLoggedInUser().subscribe((data) => {
      this.loggedInUser = data.data;
    });
  }

  getactiveuserDetails() {
    if (this.printby.footerSign) {
      this.signImg = environment.DOWNLOAD_GET_FILE + this.printby.footerSign;
    }
  }

  getOrganisationDetails() {
    this.service.getOrganizationData().subscribe((response) => {
      this.validateResponse(response, () => {
        if (response && response.data) {
          this.organization = new OrgProfileModal();
          this.organization = response.data;
          this.getImageUrl();
        } else {
          this.toaster.error('Organization data not found', 'error');
        }
      });
    });
  }

  getImageUrl() {
    if (this.organization.headerLogo) {
      this.imgURL = environment.DOWNLOAD_GET_FILE + this.organization.headerLogo;
    }
    if (this.organization.qrCode) {
      this.qrImgURL = environment.DOWNLOAD_GET_FILE + this.organization.qrCode;
    }
    // if (this.organization.footerSign) {
    //   this.signImg = environment.DOWNLOAD_GET_FILE + this.organization.footerSign;
    // }
  }

  public getTotal() {
    if (this.data && this.data.customer && this.data.customer.gstNumber && this.organization && this.organization.gstin) {
      if (this.organization.gstin.slice(0, 2) === this.data.customer.gstNumber.slice(0, 2)) {
        this.isCgst = true;
      } else {
        this.isIgst = true;
      }
    }

    if (this.data) {
      this.totalAmountWithGST = 0;
      this.totalAmount = 0;
      this.totalProductAmt = 0;
      this.totalProductQuantity = 0;
      this.totalDiscount = 0;
      this.totalGSTAmount = 0;

      this.totalProductQuantity = this.data.quotationItemDetails.reduce(
        (sum, item) => sum + parseFloat('' + (item.weight ? item.weight : 0)),
        0
      );
      this.totalProductAmt = this.data.quotationItemDetails.reduce((sum, i) => sum + parseFloat('' + ((i.weight * i.price) - i.totalDiscount)), 0);
      this.data.totalAmount = this.totalProductAmt;
      if (this.data && this.data.quotationItemDetails) {
        this.totalDiscount = this.data.quotationItemDetails.reduce((sum, item) => sum + this.getDiscountedAmount(item), 0);

        this.totalAmountWithGST = this.data.quotationItemDetails.reduce(
          (sum, item) => sum + parseFloat('' + this.getAmountWithGST(item)),
          0
        );

        this.totalGSTAmount = this.data.quotationItemDetails.reduce(
          (sum, item) => sum + parseFloat('' + this.getGstAmount(item)),
          0
        );
      }
    }
  }

  getByModuleNameId(id: number) {
    let data = [];
    this.service.getByModuleNameAndEntityId(id, 'Quotation').subscribe((res) => {
      if(res.dataList != null){
        res.dataList.forEach((res) => {
          if (res.keyName == refNo) {
            if (!this.yourRefNo) this.yourRefNo = res.value;
          }
          if (res.keyName == item) {
            this.itemWiseDesc.push(JSON.parse(res.value));
          }
        });
      }
      if (
        this.data.quotationItemDetails &&
        this.data.quotationItemDetails.length > 0 &&
        this.itemWiseDesc &&
        this.itemWiseDesc.length > 0 &&
        this.itemWiseDesc[0].length > 0
      ) {
        this.data.quotationItemDetails.forEach((d, index) => {
          this.itemWiseDesc[0].forEach((i) => {
            if (d.id == i.id) {
              d.desc = i.description;
              d.bmCode = i.buyerMaterialCode;
            }
          });
          this.addDescription(d.desc, index);
          this.addBuyerMateerialCode(d.bmCode, index);
        });
      }
    });
  }

  getDiscountedAmount(record: QuotationDetailModel) {
    return record.discount > 0
      ? record.price * record.weight -
          (record.price ? record.price : 0) * (record.weight ? record.weight : 0) * (record.discount / 100)
      : 0;
  }
  getGstAmount(record: QuotationDetailModel) {
    if (record.discount > 0) {
      return this.getDiscountedAmount(record) * (record.gst / 100);
    } else {
      return record.price * record.weight * (record.gst / 100);
    }
  }
  getAmountWithGST(record: QuotationDetailModel) {
    if (record.discount > 0) {
      return this.getDiscountedAmount(record) + this.getGstAmount(record);
    } else {
      return record.price * record.weight + this.getGstAmount(record);
    }
  }
  generatePrint() {
    this.printData = new QuotationPrintModel();
    this.paramArray = new Array<DynamicParams>();
    this.printData.quotationId = this.data.id;
    this.printData.logistic = this.data.logistic;
    this.printData.yourRefNo = this.yourRefNo;
    this.printData.buyerMaterialCode = this.buyerMaterialCodes;
    this.printData.itemDescriptionDTO = this.descriptions;
    this.printData.subjectDetails = this.subject;
    this.printData.modeOfTransport = this.modeOfTransport;
    // this.printData.buyerMaterialCode = this.buyerMaterialCodes;
    this.printData.quotationNo = this.data.quotationNo;
    this.printData.hideHeaderFooter = this.isHideHeaderFooter;
    this.printData.paymentDays = this.paymentDays;
    this.printData.quotation = this.data;
    this.quotationService.getQuotationPrint(this.printData);
    if (this.yourRefNo) {
      this.paramobj = new DynamicParams();
      this.paramobj.keyName = refNo;
      this.paramobj.value = this.yourRefNo;
      this.paramobj.valueObject = null;
      this.paramobj.entityId = this.data.id;
      this.paramobj.moduleName = moduleName;
      this.paramArray.push(this.paramobj);
    }
    if (this.data && this.data.quotationItemDetails && this.data.quotationItemDetails.length > 0) {
      this.paramobj = new DynamicParams();
      this.paramobj.keyName = item;
      this.paramobj.value = null;
      this.paramobj.valueObject = new Array<valueObjectClass>();
      this.data.quotationItemDetails.forEach((ls, index) => {
        let valueObjecttemp = new valueObjectClass();
        valueObjecttemp.id = ls.id;
        valueObjecttemp.description = this.descriptions[index] ? this.descriptions[index].description : null;
        valueObjecttemp.buyerMaterialCode = this.buyerMaterialCodes[index]
          ? this.buyerMaterialCodes[index].value
          : null;
        this.paramobj.valueObject.push(valueObjecttemp);
      });
      this.paramobj.entityId = this.data.id;
      this.paramobj.moduleName = moduleName;
      this.paramArray.push(this.paramobj);
    }
    if (this.paramArray.length > 0) {
      this.service.getPrintParameters(this.paramArray).subscribe((res) => {});
    }
  }

  addBuyerMateerialCode(value, index) {
    if (!this.buyerMaterialCodes) {
      this.buyerMaterialCodes = new Array<BuyerMaterialCode>();
    }
    let isExistingIndex: boolean;
    this.buyerMaterialCodes.forEach((ls) => {
      if (ls.index == index) {
        isExistingIndex = true;
        ls.value = value;
      }
    });
    if (!isExistingIndex) {
      var data = new BuyerMaterialCode();
      data.index = index;
      data.value = value;
      this.buyerMaterialCodes.push(data);
    }
  }
  addDescription(value, index) {
    if (!this.descriptions) {
      this.descriptions = new Array<DescriptionDTO>();
    }
    let isExistingIndex: boolean;
    this.descriptions.forEach((ls, i) => {
      if (ls.index == index) {
        isExistingIndex = true;
        ls.description = value;
      }
    });
    if (!isExistingIndex) {
      var data = new DescriptionDTO();
      data.index = index;
      data.description = value;
      this.descriptions.push(data);
    }
  }

  onModalClose() {
    this.onModalCancel.emit();
  }

  onSavePrint() {
    this.printData = new QuotationPrintModel();
    this.printData.quotationId = this.data.id;
    this.printData.logistic = this.data.logistic;
    this.printData.yourRefNo = this.yourRefNo;
    this.printData.buyerMaterialCode = this.buyerMaterialCodes;
    this.printData.itemDescriptionDTO = this.descriptions;
    this.printData.subjectDetails = this.subject;
    this.printData.modeOfTransport = this.modeOfTransport;
    // this.printData.buyerMaterialCode = this.buyerMaterialCodes;
    this.printData.quotationNo = this.data.quotationNo;
    this.printData.hideHeaderFooter = this.isHideHeaderFooter;
    this.printData.paymentDays = this.paymentDays;
    this.printData.quotation = this.data;
    this.onSave.emit(this.printData);
  }
}

export class QuotationPrintModel {
  quotation: QuotationModel;
  quotationId: number;
  buyerMaterialCode: Array<BuyerMaterialCode>;
  itemDescriptionDTO: Array<DescriptionDTO>;
  yourRefNo: string;
  subjectDetails: string;
  modeOfTransport: string;
  quotationNo: string;
  hideHeaderFooter: boolean = false;
  paymentDays: number;
  logistic: string;
}

class BuyerMaterialCode {
  index: number;
  value: string;
}

class DescriptionDTO {
  index: number;
  description: string;
}

export class DynamicParams {
  value: any;
  keyName: string;
  valueObject: Array<valueObjectClass>;
  entityId: number;
  moduleName: string;
}
export class valueObjectClass {
  id: number;
  description: string;
  buyerMaterialCode: string;
}
